import React, {useState} from 'react';
import {Check} from 'lucide-react';

export const ORIGINAL_COLORS = {
  sage:'#b1d2a4', sky:'#92c6ee', lavender:'#c3b3ef', rose:'#e9abbc',
  amber:'#edcd89', mint:'#91d8c4', slate:'#bdc9cc',
};
export const COLOR_PALETTES = {
  Soft: Object.entries(ORIGINAL_COLORS).map(([name,hex])=>({name:name[0].toUpperCase()+name.slice(1),hex,value:name})),
  Vivid: [ ['Coral','#ef6461'],['Orange','#f59e42'],['Gold','#f4ca45'],['Green','#52b788'],['Blue','#448aff'],['Violet','#a277ff'],['Pink','#ef71b5'] ].map(([name,hex])=>({name,hex,value:hex})),
  Earth: [ ['Terracotta','#bd7059'],['Ochre','#b99345'],['Olive','#87945a'],['Forest','#49796b'],['Ocean','#527d91'],['Heather','#927b9e'],['Clay','#b58f85'] ].map(([name,hex])=>({name,hex,value:hex})),
};
export function colorHex(color){return ORIGINAL_COLORS[color] || (/^#[0-9a-f]{6}$/i.test(color||'')?color.toLowerCase():ORIGINAL_COLORS.slate);}
export function customColorStyle(color){
  if(!/^#[0-9a-f]{6}$/i.test(color||''))return undefined;
  return {'--calendar-color':color,'--calendar-wash':`${color}26`};
}

export default function CalendarColorPicker({name,color,onChange,disabled}){
  const [palette,setPalette]=useState('Soft');
  const hex=colorHex(color);
  return <div className="calendar-color-picker">
    <label>Palette<select value={palette} disabled={disabled} onChange={event=>setPalette(event.target.value)}>
      {Object.keys(COLOR_PALETTES).map(key=><option key={key}>{key}</option>)}
    </select></label>
    <div className="calendar-palette-swatches" role="group" aria-label={`${palette} palette for ${name}`}>
      {COLOR_PALETTES[palette].map(swatch=><button type="button" key={swatch.value} title={`${swatch.name} ${swatch.hex}`} aria-label={`${swatch.name} ${swatch.hex}`} aria-pressed={hex===swatch.hex} disabled={disabled} onClick={()=>onChange(swatch.value)}>
        <span style={{background:swatch.hex}}/>{hex===swatch.hex&&<Check size={13} aria-hidden="true"/>}
      </button>)}
    </div>
    <label className="calendar-custom-color">Custom color<input type="color" aria-label={`Custom color for ${name}`} value={hex} disabled={disabled} onInput={event=>onChange(event.currentTarget.value)} onChange={event=>onChange(event.target.value)}/><code>{hex.toUpperCase()}</code></label>
    <p className="calendar-hint">Choose a swatch or use the picker for any color.</p>
  </div>;
}
